import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Seperator } from './Seperator';
import './css/GroupInfoModal.css';

export function GroupInfoModal({ shown, closeModal, group }) {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        if (shown) {
            $('#group-modal-container').fadeIn(300);
            $('#group-modal-container').css('display', 'flex');
            $('#group-modal').css({ "margin-left": "2000px" }).animate({ "margin-left": "0px" }, 300)
            fetchUsers();
        }
    }, [shown])

    function fetchUsers() {
        fetch(`/api/groups/${group.uuid}/users`)
            .then(response => response.json())
            .then(result => {
                setUsers(result)
            })
            .catch(error => console.log('error', error));
    }

    return (
        <>
            <div className="group-info-container" id="group-modal-container"
                onClick={(event) => {
                    var $target = $(event.target);
                    if (!$target.closest('#group-modal').length &&
                        $('#group-modal-container').is(":visible")) {
                        closeModal();
                        $('#group-modal-container').fadeOut(300);
                        $('#group-modal').css("margin-left", "0px")
                            .animate({ "margin-left": "2000px" }, 300);
                    }
                }}>
                <div className="group-info" id="group-modal" onClick={(e) => { e.stopPropagation() }}>
                    <div className="bar">
                        <div className="info-title">
                            Group Name:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF" }}>
                            {group?.name}
                        </div>
                    </div>
                    <Seperator width={726} />
                    {users.map(user => {
                        return (
                            <div className="bar">
                                <div className="info-title">
                                    username:
                                </div>
                                <div className="text-18pt" style={{ color: "#094EFF" }}>
                                    {user.username}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    );
}
